import { PropsWithChildren } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import { useAuth } from '@app/auth/auth-context'
import { routeOperations } from '@app/auth/permissions'
import { AccessDeniedPage } from '@pages/access-denied/ui/page'
import { ArchivePage } from '@pages/archive/ui/page'
import { DashboardPage } from '@pages/dashboard/ui/page'
import { ExercisePage } from '@pages/exercise/ui/page'
import { MediaPage } from '@pages/media/ui/page'
import { NotFoundPage } from '@pages/not-found/ui/page'
import { ProgramsPage } from '@pages/programs/ui/page'
import type { AdminOperationId } from '@shared/api'
import { AppShell } from '@shared/layout/app-shell'

type RequireOperationProps = PropsWithChildren<{ operation: AdminOperationId }>

export const RequireOperation = ({ children, operation }: RequireOperationProps) => {
	const { isAuthenticated, can } = useAuth()
	if (!isAuthenticated || !can(operation)) {
		return <Redirect to='/access-denied' />
	}
	return <>{children}</>
}

export const AppRouter = () => (
	<AppShell>
		<Switch>
			<Route path='/' exact>
				<RequireOperation operation={routeOperations.dashboard}>
					<DashboardPage />
				</RequireOperation>
			</Route>
			<Route path='/exercises'>
				<RequireOperation operation={routeOperations.exercises}>
					<ExercisePage />
				</RequireOperation>
			</Route>
			<Route path='/programs'>
				<RequireOperation operation={routeOperations.programs}>
					<ProgramsPage />
				</RequireOperation>
			</Route>
			<Route path='/media'>
				<RequireOperation operation={routeOperations.media}>
					<MediaPage />
				</RequireOperation>
			</Route>
			<Route path='/archive'>
				<RequireOperation operation={routeOperations.archive}>
					<ArchivePage />
				</RequireOperation>
			</Route>
			<Route path='/access-denied'>
				<AccessDeniedPage />
			</Route>
			<Route>
				<NotFoundPage />
			</Route>
		</Switch>
	</AppShell>
)
